/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSignal2g = createReactComponent("outline", "signal-2g", "IconSignal2g", [["path", { "d": "M19 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1", "key": "svg-0" }], ["path", { "d": "M5 8h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h4", "key": "svg-1" }]]);

export { IconSignal2g as default };
//# sourceMappingURL=IconSignal2g.mjs.map
